<template>
    <div>
        <ul class="tachyon_search_list">
            <template v-for="(result) in resultList">
                <template v-if="result.data.length > 0">
                    <li :key="result.filter" class="filter_list">{{ result.filter }}</li>
                    <template v-for="(data) in result.data">
                        <li :key="data.url" class="data_list">
                            <a :href="data.url">
                            <span>
                                <span class="data_name">{{data.name}}</span>
                                <span class="data_contents">({{data.contents}})</span>
                            </span>
                            </a>
                        </li>
                    </template>
                </template>
            </template>
            <li v-if="resultList.length == 0" class="empty_data">
                결과를 찾을 수 없습니다. "{{searchValue}}"
            </li>

        </ul>
    </div>
</template>
<script>
export default{
    name: 'SearchResult',
    props: {
        resultList: {
            type: Array,
            default: () => []
        },
        searchValue: {
            type: String
        }
    },
    data () {
        return {

        }
    },
    methods: {

    }
}
</script>

<style>
    .tachyon_search_list {
        position: absolute;
        left: 0;
        z-index: 1000;
        width: 100%;
        min-width: 160px;
        margin: 2px 0 0;
        list-style: none;
        text-align: left;
        background-color: #fff;
        background-clip: padding-box;
        max-height: 500px;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
    .tachyon_search_list li {
        position: relative;
        border-top: solid 1px #e0e0e0;
    }
    .filter_list {
        border-top: solid 1px #d9dbdc;
        cursor: default;
        color: #4f555a;
        background: #eaeaea;
        display: block;
        padding: 10px 18px;
        clear: both;
        text-decoration: none;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        font-weight: bold;
    }
    .data_list {
        border-color: #d9dbdc;
    }
    .data_list a {
        display: block;
        padding: 0.5rem 0.75rem;
        clear: both;
        color: #424242;
        text-decoration: none;
        font-size: 13px;
    }
    .data_list a:hover {
        background-color: #f5f5f5;
        color: #3c3c3c;
    }
    .data_name {
        font-size: 16px;
        font-weight: bold;
        line-height: 28px;
        display: block;
        color: #3272c0;
    }
    .data_contents {
        /* width: 100%; */
        height: auto;
        padding: 0 18px 0 18px;
        font-size: 13px;
        font-weight: normal;
        line-height: 23px;
        display: block;
        word-break: keep-all;
    }
    .empty_data {
        padding: 0.5rem 0.75rem;
        color: #424242;
        font-size: 13px;
    }
</style>